import { useState } from "react";
import { fileUrl } from "@/lib/api";
import { ChevronLeft, ChevronRight } from "lucide-react";

export default function PhotoGallery({ photos = [], height = 112, rounded = false, testId }) {
  const [i, setI] = useState(0);
  const [sx, setSx] = useState(null);
  if (!photos || !photos.length) return null;
  const n = photos.length;
  const go = (d, e) => { if (e) e.stopPropagation(); setI((p) => (p + d + n) % n); };
  return (
    <div className="relative group overflow-hidden" style={{ height }} data-testid={testId}
      onTouchStart={(e) => setSx(e.touches[0].clientX)}
      onTouchEnd={(e) => { if (sx == null) return; const dx = e.changedTouches[0].clientX - sx; if (dx > 40) go(-1); else if (dx < -40) go(1); setSx(null); }}>
      <img src={fileUrl(photos[i])} alt="" className={`w-full h-full object-cover ${rounded ? "rounded-lg" : ""}`} />
      {n > 1 && (
        <>
          <button type="button" onClick={(e) => go(-1, e)} className="absolute left-1 top-1/2 -translate-y-1/2 bg-black/50 text-white rounded-full p-1 opacity-0 group-hover:opacity-100 transition-opacity" data-testid={testId ? `${testId}-prev` : undefined}><ChevronLeft className="w-4 h-4" /></button>
          <button type="button" onClick={(e) => go(1, e)} className="absolute right-1 top-1/2 -translate-y-1/2 bg-black/50 text-white rounded-full p-1 opacity-0 group-hover:opacity-100 transition-opacity" data-testid={testId ? `${testId}-next` : undefined}><ChevronRight className="w-4 h-4" /></button>
          <div className="absolute bottom-1 left-0 right-0 flex justify-center gap-1">
            {photos.map((_, d) => <span key={d} className={`w-1.5 h-1.5 rounded-full transition-colors ${d === i ? "bg-white" : "bg-white/50"}`} />)}
          </div>
        </>
      )}
    </div>
  );
}
